import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'

import { CardNotificationBase } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'
import { PENGELOLAAN_KINERJA_GURU_PATH } from 'app/KinerjaShared/constants/path'

import type { CardNotificationBaseProps } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'

export function CardNotificationConfirmUnor({
  ...cardProps
}: CardNotificationBaseProps) {
  return (
    <CardNotificationBase {...cardProps}>
      <div className="mt-6">
        <Link
          href={`${PENGELOLAAN_KINERJA_GURU_PATH}/konfirmasi-unor`}
          passHref
        >
          <Button as="a" className="!inline-flex">
            Konfirmasi data
          </Button>
        </Link>
      </div>
    </CardNotificationBase>
  )
}
